import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import MaterialTable from 'material-table';
import { Container } from '@material-ui/core';
import React, { useEffect, useState, useRef } from 'react';

import api from '../../../../services/api.js';

import Add from './Components/Add.js'
import Edit from './Components/Edit.js'
import Del from './Components/Del.js'

export default function MyTable(props) {
    const tableRef = useRef();
    const snack = useRef()
    const { enqueueSnackbar } = useSnackbar();
    snack.current = enqueueSnackbar

    const [termos, setTermos] = useState([]);

    const state = {
        columns: [
            {
                title: "Opções", field: "opcoes", cellStyle: { width: '5%', textAlign: "center", },
                render: (rowData) => {
                    return (
                        <div style={{ display: 'flex', alignitems: 'center' }}>
                            <Edit setData={props.setData} setOpen={props.setOpen} data={rowData} />
                            <Del setReload={props.setReload} data={rowData} />
                        </div>
                    )
                }
            },
            {
                title: "Usina", field: "usina",
                render: (rowData) => {
                    return (
                        <>
                            {rowData.usina_atuacao.map(txt => <p>{txt}</p>)}
                        </>
                    )
                }
            },
            { title: "Termos", field: "termos" },
            { title: "Ações", field: "acao" },
            { title: "Tipo", field: "status" },
        ],
    };

    useEffect(() => {
        async function fetchData() {
            api.get(`/epae`)
                .then((res) => {
                    let termos = []
                    for (let user of res.data) {
                        let usina_atuacao = []
                        for (let usina of user.usinas) {
                            usina_atuacao.push(usina.nome)
                        }
                        let aux = {
                            _id: user._id,
                            termos: user.termos,
                            acao: user.acao,
                            usina_atuacao: usina_atuacao,
                            usinas: user.usinas,
                            status: user.status,
                            criado_por: user.criado_por,
                            criado_em: user.criado_em,
                            editado_por: user.editado_por,
                            editado_em: user.editado_em,
                        }
                        termos.push(aux)
                    }
                    setTermos(termos)
                })
                .catch((error) => {
                    console.log(error);
                    snack.current("Falha ao buscar e-PAE", { variant: 'error' })
                });
        }
        fetchData();
    }, [props.reload]);


    return (
        <Container maxWidth={false} spacing={2}>
            <MaterialTable
                tableRef={tableRef}
                title="e-PAE"
                columns={state.columns}
                data={termos}
                options={{
                    search: true,
                    pageSize: 10,
                    exportButton: false,
                    emptyRowsWhenPaging: false,
                    pageSizeOptions: [1, 5, 10, 20, termos.length],
                    padding: "dense",
                    headerStyle: {
                        textAlign: "center",
                        color: "#b31b1b",
                    },
                    cellStyle: {
                        textAlign: "center",
                    },
                }}

                localization={{
                    body: {
                        emptyDataSourceMessage: "",
                        addTooltip: "adicionar novo",
                        deleteTooltip: "excluir",
                        editRow: { deleteText: "Deseja excluir?" },
                    },

                    header: {
                        actions: "Opções",
                    },

                    toolbar: {
                        searchTooltip: "Pesquisar",
                        searchPlaceholder: "Pesquisar",
                        exportTitle: "exportar",
                        nRowsSelected: "{0} Usuários(s) selecionados",
                    },
                    pagination: {
                        labelRowsSelect: "",
                        labelDisplayedRows: "{count} de {from}-{to}",
                        firstTooltip: "Primeira página",
                        previousTooltip: "Página anterior",
                        nextTooltip: "Próxima página",
                        lastTooltip: "Última página",
                    },
                }}
                components={{
                    Actions: () => {
                        return (
                            <Add setData={props.setData} setOpen={props.setOpen} />
                        );
                    }
                }}
            />
        </Container >
    );
}

MyTable.propTypes = {
    reload: PropTypes.bool,
    setData: PropTypes.func,
    setOpen: PropTypes.func,
    setReload: PropTypes.func,
    setAffiliates: PropTypes.func,
};
